'use client'

import { Dialog } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import {
  ComplaintResolutionAction,
  getComplaint,
  transformComplaintDto,
} from '@marketplace-web/complaints/complaints-data'

type Props = {
  complaintId?: string | null
  isOpen: boolean
  onSubmit: () => void
  onClose: () => void
}

const ResolveIssueModal = ({ complaintId, isOpen, onSubmit, onClose }: Props) => {
  const translate = useTranslate('conversation.actions.resolve_complaint.modal')

  const {
    fetch: fetchComplaint,
    transformedData: complaint,
    isLoading,
  } = useFetch(getComplaint, transformComplaintDto)

  const resolutionAction = complaint?.resolutions?.find(
    resolution => resolution.action === ComplaintResolutionAction.Refund,
  )

  useEffect(() => {
    if (!complaintId || !isOpen) return

    fetchComplaint(complaintId)
  }, [fetchComplaint, complaintId, isOpen])

  if (isLoading) {
    return (
      <Dialog show>
        <ContentLoader testId="resolve-issue-modal-loader" />
      </Dialog>
    )
  }

  if (!resolutionAction) return null

  return (
    <Dialog
      show={isOpen}
      title={resolutionAction?.confirmTitle}
      body={resolutionAction?.confirmation}
      actions={[
        {
          text: resolutionAction?.confirmButton,
          style: Dialog.ActionStyling.Filled,
          callback: onSubmit,
          testId: 'resolve-issue-modal--submit-button',
        },
        {
          text: translate('cancel'),
          style: Dialog.ActionStyling.Flat,
          callback: onClose,
        },
      ]}
    />
  )
}

export default ResolveIssueModal
